module.exports = __webpack_public_path__ + "img/img9.b36c24d2.png";